$(document).ready(function() {

    calculateSubmenuPositions();
    $( window ).resize(function() {
        calculateSubmenuPositions();
    });
    //$(".secondary-menu div[data-btn-id='rides']").offset({left:($(".menu-button[data-btn-id='rides']").offset().left + ($(".menu-button[data-btn-id='rides']").width() / 2)) - ($(".secondary-menu div[data-btn-id='rides']").width() / 2)});


    $('#headerBar').mouseover(function(){
        $(this).addClass('show');
    });

    $('#headerBar').mouseout(function(){
        if($('.secondary-menu').css('opacity') == "0"){
            $(this).removeClass('show');
            $('.secondary-menu .subtext').removeClass('show');
        }
    });

    var force = false;
    $('.menu-button').mouseover(function(){

        // $('.secondary-menu').find('[data-btn-id]').css('z-index','0');
        $('.secondary-menu .subtext').removeClass('show');
        $('.secondary-menu').addClass('show').find('[data-btn-id=' + $(this).data('btn-id') + '] .subtext').addClass('show');
        // $('.secondary-menu').addClass('show').find('[data-btn-id=' + $(this).data('btn-id') + ']').css('z-index','999');

        $height = $('.secondary-menu').find('[data-btn-id=' + $(this).data('btn-id') + ']').height();
        force = false;
        handleCursorDistance($(this));
        $('.secondary-menu').css({'height':$height * 1.1});
    });


    var mX, mY, distance;

    function calculateDistance(elem, mouseX, mouseY) {

        horizontal = Math.floor(Math.sqrt(Math.pow(mouseX - (elem.offset().left+(elem.width()/2)), 2)));
        vertical =  Math.floor(Math.sqrt(Math.pow(mouseY - (elem.offset().top+(elem.height()/2)), 2)));

        return {'x': horizontal, 'y': vertical};
    }

    function handleCursorDistance($element){
        $(document).mousemove(function(e) {
            if($('.secondary-menu').css('opacity') == "1"  && !checkMobile()) {

                if ($('.secondary-menu').css('opacity') == "0" || force) return;
                mX = e.pageX;
                mY = e.pageY;
                distance = calculateDistance($element, mX, mY);

                height = $('#headerBar').height() + $('.secondary-menu').height() /*- $element.offset().top*/;
                width = ($element.width() / 2) + 15;

                if (distance.y > height) {
                    $('.secondary-menu').removeClass('show').css('height',0);
                    $('#headerBar').removeClass('show');
                    $('.secondary-menu .subtext').removeClass('show');
                    $(document).off('mousemove');
                }

                if(distance.x > width){
                    if(e.target.nodeName != 'path' && e.target.nodeName != 'svg'){
                        if(e.target.nodeName  != 'A' && !(e.target.className?e.target.className.includes('secondary-menu-item'):false) && e.target.nodeName  != 'LI'){
                            $('#headerBar').removeClass('show');
                            $('.secondary-menu').removeClass('show').css('height',0);
                            $('.secondary-menu .subtext').removeClass('show');
                            $(document).off('mousemove');
                        }
                    }
                }
            }
        });
    }

    /* Scrolling up menu bar */
    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop || st == 0){
            // scrolling down
            $('#headerBar').removeClass('show fixed-top');
            $('.secondary-menu').removeClass('fixed-top-sec');
        } else {
            //pas vanaf een bepaalde diepte scrolling up activeren
            if(st > 300){
                // scrolling up
                $('#headerBar').addClass('show fixed-top');
                $('.secondary-menu').addClass('fixed-top-sec');
            }
        }
        lastScrollTop = st;
    });
    // console.log($("#mobileheaderBar").is(':visible'));

        $('#mobileheaderBar.language-selector-wrapper, .open_on_touch').on('click', function (e) {


            if ( $('.language-selector').is(":visible") == false) {
                $('.language-selector').addClass('show').show();
            }
            else {
                $('.language-selector').removeClass('show').hide();
            }
        });

        $('#mobileheaderBar.language').on('touchend',function(e){
            window.location = $(this).find('a').attr('href');
        });

    $('[data-toggle][data-callback]').click(function() { if(!$(this).attr('data-target')) window.location = $(this).attr('data-callback') || window.location });

    /* header button hover stuff */
    $('.action-button').on('click',function(){
        if($(this).data('href')) window.location = $(this).data('href');

    });

    $('.action-button').not('#share').on('mouseover',function(){
        // $(this).find('.text')/*.animate({"margin-left": '+=100'})*/.show();
        $(this).find('.icon_counter').removeClass('d-md-block');
    });

    $('.action-button').not('#share').on('mouseleave',function(){
        // $(this).find('.text').hide();
        $(this).find('.icon_counter').addClass('d-md-block');
    });
    /* ================== */

    $(document).click(function(e) {
        if (!$(e.target).is('.header') && !$(e.target).is('#headerBar') && $('.collapse').is(':visible')) {
            $('#mainMenu.collapse').collapse('hide');
            $('#nav-toggler').removeClass('open');


        }
    });

    $(".password_eye").click(function(){
        pwd = $(this).siblings('input');
        if(pwd.attr("type")=="password"){
            pwd.attr("type","text");
        } else {
            pwd.attr("type","password");
        }
    });

    $(".close-privacy-banner").on( "click", function() {
            $.ajax({
                url: "/index/hideprivacybannerajax",
                context: document.body,
                success: function(){
                    $(".privacy-banner").addClass("d-none");
                    $(".has-privacy-banner").removeClass("has-privacy-banner");
                },
            });
        }
    );

});



function calculateSubmenuPositions(){
    $(".secondary-menu div").each(function(e){

        $id = $(this).data('btn-id');
        $width = $(this).width();

        $left_offset= $(this).offset().left;

        if($id){
            $parent_element = $('.menu-button[data-btn-id=' + $id + ']:visible');

            if($parent_element.length){
                $parent_width = $parent_element.width();
                $parent_left_offset = $parent_element.offset().left;
                $parent_right_offset = $(window).width() - $parent_width - $parent_left_offset;
                $parent_center_offset = $parent_left_offset + ($parent_width / 2);

                $new_left_offset = $parent_center_offset - ($width / 2);

                if($id && $.inArray($id,['language','profile','notifications','more','login']) != '-1'){
                    // $new_left_offset = $new_left_offset - ($parent_width/2);
                    $(this).css({'position':'absolute', 'right': $parent_right_offset});
                }
                else{
                    $(this).css('position','absolute').offset({left: $new_left_offset});
                }
            }
        }
    });
}
